module.exports = __webpack_public_path__ + "static/img/victim-teens-6.ac62451b.png";